<template>
    <div class="d-flex align-items-stretch">
        <parens left />
        <div
            v-bind:class="{ 'flex-column': wrap }"
            class="d-flex align-items-center">
            <component
                v-bind:is="formulaControl.childExpressionComponent"
                v-if="isBaseComputed"
                v-bind:child-binder="base" />
            <div
                v-else
                class="fw-bold fst-italic mx-2">
                e
            </div>
            <div v-bind:class="operatorClassName">^</div>
            <component
                v-bind:is="formulaControl.childExpressionComponent"
                v-bind:child-binder="expArg" />
        </div>
        <parens />
    </div>
</template>
<script>
    import base from "./_baseExpression.vue";

    export default {
        extends: base,
        props: {
            expression: { type: Object, required: true }
        },
        computed: {
            isBaseComputed() {
                return this.metadata.numOperands === 2;
            },
            base() {
                if (this.isBaseComputed) {
                    return this.getChildBinderByIndex(1);
                }
                return null;
            },
            expArg() {
                return this.getChildBinderByIndex(0);
            }
        }
    };
</script>
